module.exports = __webpack_public_path__ + "static/Audrey_Foncelle-d5dfb300daac238a39a002597859dc48.png";